export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-gif-ru-0b2360177c771e626f987ec8dd95e175.gif";